import { GTM_EVENTS } from './widget-constants';

export const GA4_EVENT_NAMES: Record<keyof typeof GTM_EVENTS, string> = {
  ...GTM_EVENTS,
  APPOINTMENT_BOOKING_STEP_STORES_AND_SERVICES: 'appointment_step_stores_services',
  APPOINTMENT_BOOKING_STEP_AVAILABLE_APPOINTMENTS: 'appointment_step_datetime',
  PRE_DEFINED_SLOT_BOOKING_STEP_SELECT_SLOT: 'predefined_slot_step_select_slot',
  PRE_DEFINED_SLOT_BOOKING_STEP_PERSONAL_INFO: 'predefined_slot_step_personal_data',
  COMPACT_WIDGET_BOOKING_STEP_AVAILABLE_APPOINTMENTS: 'compact_step_datetime'
};
